export default [{"tag":"path","att":{"d":"m13 18 8-6-8-6v12zm-9 0 8-6-8-6v12z"}}]